import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-设备模板",
  "use": "icon-设备模板-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-设备模板\"><path fill=\"none\" d=\"M0 0h18v18H0z\" data-name=\"矩形 5964\" /><path d=\"M3.998 17a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Zm-1-14v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1.006-1V3a1 1 0 0 0-1.006-1h-10a1 1 0 0 0-1 1m1.5 10a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5Zm.5-4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Zm0-1h8V6h-8Z\" data-name=\"联合 1235\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol